import { render, staticRenderFns } from "./reportIssue.vue?vue&type=template&id=2da78b2f"
import script from "./reportIssue.vue?vue&type=script&lang=js"
export * from "./reportIssue.vue?vue&type=script&lang=js"
import style0 from "./reportIssue.vue?vue&type=style&index=0&id=2da78b2f&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports